// Чистая логика аналитики (T9): карта целей и трекер с буфером до прихода конфига.
// Браузерный клей (window.ym, вставка тега счётчика) — в ../metrika.js.

// data-okb действия → идентификаторы целей Метрики (ROADMAP T9)
export const GOALS = {
  "open-dates": "calendar_open",
  "pick-in": "checkin_pick",
  "pick-out": "checkout_pick",
  book: "book_click",
};

const BUFFER_CAP = 20;

// send(counterId, goal) впрыскивается снаружи (в тестах — стаб). Номер счётчика приходит
// асинхронно из /api/config, а первые клики возможны раньше — до init(id) события копятся
// (кап BUFFER_CAP, старые отбрасываются), init(id) их флашит; init(null) = счётчика нет,
// всё выброшено и дальнейшие вызовы — no-op.
export function createTracker(send) {
  let counterId = null;
  let inited = false;
  let buffer = [];
  const paidSent = new Set();
  const createdSent = new Set();

  function emit(goal) {
    if (!inited) {
      buffer.push(goal);
      if (buffer.length > BUFFER_CAP) buffer.shift();
      return;
    }
    if (counterId != null) send(counterId, goal);
  }

  return {
    init(id) {
      if (inited) return;
      inited = true;
      counterId = id ?? null;
      const pending = buffer;
      buffer = [];
      if (counterId != null) for (const goal of pending) send(counterId, goal);
    },
    goal(name) {
      if (name) emit(name);
    },
    // book_paid один раз на заказ: экран статуса может перезапроситься/перерисоваться
    paid(orderToken) {
      const key = String(orderToken ?? "");
      if (paidSent.has(key)) return;
      paidSent.add(key);
      emit("book_paid");
    },
    // book_created (T34) — успешный ответ /api/book, один раз на бронь: при «Оплате в отеле»
    // book_paid не наступает, и без этой цели воронка обрывалась на book_click
    created(bookingKey) {
      const key = String(bookingKey ?? "");
      if (createdSent.has(key)) return;
      createdSent.add(key);
      emit("book_created");
    },
  };
}
